// import { Header } from 'antd/lib/layout/layout'
import React from 'react'
// import { motion } from 'framer-motion'

const Helmet = () => {
  return (
    <></>
    // <Header>
    //   <motion.div
    //     initial={{ x: 0, opacity: 0 }}
    //     transition={{ ease: 'easeIn', duration: 0.8, delay: 0 }}
    //     animate={{ opacity: [0, 1], x: [100, 0] }}
        
    //   >
        
    //   </motion.div>

    // </Header>
  )
}

export default Helmet
